import { Reveal, Overline } from "./Reveal";

const A = "https://customer-assets-0z36b82j.emergentagent.net/job_7d05bada-2779-41ea-90b1-d0980c2c7baf/artifacts/";

const projects = [
  {
    title: "Commercial Kitchen Fit-Out",
    type: "Restaurant Build-Out",
    location: "Virginia Beach, VA",
    img: A + "6k99sbcl_20260524_090420.webp",
    span: "md:col-span-2 md:row-span-2",
    tall: true,
  },
  {
    title: "Modern Office Refresh",
    type: "Commercial Interior",
    location: "Arlington, VA",
    img: "https://images.unsplash.com/photo-1758498231185-2386de2723af?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    span: "md:col-span-2",
  },
  {
    title: "Exterior Deck & Framing",
    type: "Residential Addition",
    location: "Alexandria, VA",
    img: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=1200&q=80",
    span: "md:col-span-1",
  },
  {
    title: "Full Interior Remodel",
    type: "Residential",
    location: "Richmond, VA",
    img: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1200&q=80",
    span: "md:col-span-1",
  },
  {
    title: "Luxury Kitchen Remodel",
    type: "Residential Kitchen",
    location: "Fairfax, VA",
    img: "https://images.pexels.com/photos/35189708/pexels-photo-35189708.jpeg?auto=compress&cs=tinysrgb&w=1000",
    span: "md:col-span-2",
  },
  {
    title: "Bright Living Space",
    type: "Full-Home Remodel",
    location: "Norfolk, VA",
    img: "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    span: "md:col-span-2",
  },
];

export default function Portfolio() {
  return (
    <section id="work" className="relative py-24 md:py-36 bg-brand-navy" data-testid="portfolio-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <Reveal>
              <Overline>Featured Work</Overline>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-6 font-heading text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter text-brand-text leading-[1.02]">
                Recent projects.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <a
              href="#contact"
              className="inline-flex items-center gap-2 border border-brand-hi hover:border-brand-orange text-brand-text px-6 py-3 rounded-sm font-semibold transition-colors"
              data-testid="portfolio-cta"
            >
              Discuss your project
            </a>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 md:gap-5 auto-rows-[260px]">
          {projects.map((p, i) => (
            <Reveal
              key={p.title}
              delay={0.05 * (i % 3)}
              className={`${p.span} ${p.tall ? "row-span-1 md:row-span-2 h-full" : ""}`}
            >
              <div className="group relative h-full w-full overflow-hidden rounded-sm border border-brand-hi" data-testid={`project-card-${i}`}>
                <img
                  src={p.img}
                  alt={p.title}
                  className="absolute inset-0 w-full h-full object-cover grayscale-[30%] group-hover:grayscale-0 transition-all duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-navy via-brand-navy/20 to-transparent opacity-90 group-hover:opacity-95 transition-opacity" />
                <div className="absolute inset-0 p-6 flex flex-col justify-end">
                  <span className="text-xs uppercase tracking-[0.2em] text-brand-orange font-bold">{p.type}</span>
                  <h3 className="font-heading text-xl md:text-2xl font-semibold text-brand-text mt-2 translate-y-2 group-hover:translate-y-0 transition-transform duration-500">
                    {p.title}
                  </h3>
                  <p className="text-sm text-brand-muted mt-1">{p.location}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
